import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { NavigationItem } from '@stylehaven/components';
import { Observable } from 'rxjs';
import { RecordService } from '../../record/services/record.service';
import { OverviewOptionsService } from '../../services/store/overview-options.service';
import { RecordIndex } from '../../state/overview-page-cache/overview-page-cache.entity';
import { OverviewOptions } from '../../state/overview/overview-options.entity';
import { BackToSearchNavigationCreator } from '../service/back-to-search-navigation.creator';
import { PrevNextRecordNavigationItemCreator } from '../service/prev-next-result-navigation-creator.service';

@Injectable()
export class RecordHeaderSandboxService {
    constructor(
        private readonly translateService: TranslateService,
        private overviewOptionsService: OverviewOptionsService,
        private backToSearchNavigationCreator: BackToSearchNavigationCreator,
        private nextResultNavigationCreator: PrevNextRecordNavigationItemCreator,
        private recordServivce: RecordService
    ) {}

    public getOverview(overviewId: string): Observable<OverviewOptions | undefined> {
        return this.overviewOptionsService.getOverviewOptions(overviewId);
    }

    public getOverviewFromStack(overviewContextToIgnore?: string): Observable<OverviewOptions | undefined> {
        return this.overviewOptionsService.peekStack(overviewContextToIgnore);
    }

    public getRecordIndex(overviewId: string, recordId: string): Observable<RecordIndex | undefined> {
        return this.overviewOptionsService.getIndexOfRecord(overviewId, recordId);
    }

    public getPrimaryNavItems(overviewOptions: OverviewOptions | undefined): NavigationItem[] {
        if (!overviewOptions) {
            return [];
        }
        const primaryNavItems: NavigationItem[] = [];

        const backToSearch: NavigationItem | undefined =
            this.backToSearchNavigationCreator.getNavigationItem(overviewOptions);
        if (backToSearch) {
            primaryNavItems.push(backToSearch);
        }

        return primaryNavItems;
    }

    public getSecondaryNavItems(viewOptions: OverviewOptions, currentIndex: RecordIndex): Observable<NavigationItem[]> {
        return this.nextResultNavigationCreator.getNavigationItems(viewOptions, currentIndex);
    }

    public translate(token: string, params?: Params | undefined): string {
        return this.translateService.instant(token, params);
    }

    public getRejections(recordId: string) {
        return this.recordServivce.getRejections(recordId);
    }
}
